module.exports = __webpack_public_path__ + "img/42000.7162cf42.jpg";